export enum MaintenanceLogEntryModelState {
	ONGOING = 'ONGOING',
	SOLVED = 'SOLVED'
}
